/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/floor': {
    width: 25,
    height: 25,
    viewBox: '0 0 25 25',
    data: `
      <path d="M22.5 1H2C1.44772 1 1 1.44772 1 2V22.5C1 23.0523 1.44772 23.5 2 23.5H22.5C23.0523 23.5 23.5 23.0523 23.5 22.5V2C23.5 1.44772 23.0523 1 22.5 1Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6.25 23.5V10.75C6.25 10.5511 6.32902 10.3603 6.46967 10.2197C6.61032 10.079 6.80109 10 7 10H17.5C17.6989 10 17.8897 10.079 18.0303 10.2197C18.171 10.3603 18.25 10.5511 18.25 10.75V23.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12.25 10V23.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.5 7L7.75 4L10 7" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M18.25 4L16 7L13.75 4" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    `
  }
})
